// eslint-disable-next-line import/no-extraneous-dependencies
import 'regenerator-runtime/runtime'; // Required for ExcelJS to work with bare.min.js version (which in turn is required to prevent unsafe-eval)
import Excel from 'exceljs'
import { saveAs } from 'file-saver'

export default async function exportToExcel(columns, data, status, totalCount, exportFilename, title) {
    const deviceOverviewColumns = ["Ημερομηνία Εισαγωγής", "ΙΜΕΙ Συσκευής", "ΙΜSΙ Sim Κάρτας", "Hμ/νία Τροποποίησης", "Αριθμός Κιβωτίου", "Κατάσταση"]
    const workbook = new Excel.Workbook();

    const worksheet = workbook.addWorksheet("My Sheet");

    const newColumnsWithHeader = columns.map(col => {
        const newCol = { ...col, header: col.title, width: 22 }
        return newCol
    })
    worksheet.columns = newColumnsWithHeader

    if(title){
    worksheet.insertRow(1, []);
    worksheet.mergeCells(1, 1, 1, newColumnsWithHeader.length); 
    const titleCell = worksheet.getCell('A1');
    titleCell.value = title;
    titleCell.alignment = { horizontal: 'center', vertical: 'middle' };
    titleCell.font = { size: 13, bold: true };
    }
    
    const isDeviceOverviewExcel = columns.every((col, index) => {
        if (col.title === deviceOverviewColumns[index]) return true
        return false
    })

    if (isDeviceOverviewExcel) {
        worksheet.mergeCells('A2:E2')
        worksheet.getRow(2).values = [`${totalCount}`, `${status}`]
    }

    data.forEach(item => {
        worksheet.addRow(item);
    })


    const buf = await workbook.xlsx.writeBuffer()
    saveAs(new Blob([buf]), exportFilename ? `${exportFilename}.xlsx` : 'report.xlsx')
}

